export default "__VITE_ASSET__rx4SMBqV__"